var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8927 1.51978L37.1707 9.38388C40.275 12.2812 41.9306 16.2133 41.9306 20.5592C41.9306 24.6983 43.5862 28.6303 46.4835 31.5277L47.5183 32.5624L57.038 1.72671",
    fill: "#2029DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.747437 29.0442L12.1297 28.6303C16.2688 28.4234 20.4078 30.079 23.3051 32.9763C26.2024 35.8736 30.1345 37.3222 34.2735 37.3222H35.7221L20.4078 8.96997",
    fill: "#2029DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.747385 68.3648L8.40456 60.0867C11.3019 56.9825 15.2339 55.1199 19.373 55.1199C23.512 55.1199 27.2371 53.2574 30.1344 50.36L31.1692 49.3253L0.126526 40.4264",
    fill: "#2029DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8926 95.6824L28.2718 84.3001C28.0648 80.1611 29.5135 76.022 32.4108 72.9178C35.1012 70.0205 36.7568 65.8814 36.5498 61.9494V60.5007L8.40448 76.4359",
    fill: "#2029DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2134 94.8545L59.7284 87.4042C56.6242 84.7139 54.7616 80.7818 54.5547 76.4358C54.3477 72.2968 52.4851 68.5717 49.5878 65.6744L48.5531 64.6396L40.275 95.8892",
    fill: "#2029DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.117 66.0884L83.7347 66.9162C79.5957 67.3301 75.4566 65.8815 72.3524 62.9842C69.2481 60.2938 65.3161 58.8451 61.177 59.0521H59.7284L76.2845 86.7835",
    fill: "#2029DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2545 26.9745L86.0112 35.6664C83.3209 38.7707 79.3888 40.8402 75.2498 41.0472C71.1108 41.2541 67.3856 43.1167 64.6953 46.2209L63.8675 47.2557L95.324 54.7059",
    fill: "#2029DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0743 0.691895L65.1091 12.0742C65.523 16.2132 64.2813 20.3522 61.384 23.6635C58.6937 26.7677 57.4519 30.6998 57.6589 34.8388L57.8658 36.2874L85.1834 19.1105",
    fill: "#2029DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo5);
export default __webpack_public_path__ + "static/media/logo5.62264dbc7168f642b18043ea66cfde55.svg";
export { ForwardRef as ReactComponent };